import { Telemetry,ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

import { IMobileSecuritySettings } from './serverApi/types/IMobileSecuritySettings';

// List of events. The event name will be what appears in the database.
export enum MobileSecuritySettingsTelemetryEvents {
  mobile_security_settings = 'mobile_security_settings',
}

export enum MobileSecuritySettingsTelemetrySettingLocation {
  server_settings = 'server_settings',
  site_settings = 'site_settings'
}

export interface UpdateMobileSecuritySettingsEvent extends ValidTelemetryEvent {
  type: MobileSecuritySettingsTelemetryEvents;
  location: MobileSecuritySettingsTelemetrySettingLocation;
  jailbroken_device_ios_enabled: boolean;
  jailbroken_device_ios_value: string;
  jailbroken_device_ios_severity: string;
  jailbroken_device_android_enabled: boolean;
  jailbroken_device_android_value: string;
  jailbroken_device_android_severity: string;
  block_screenshot_android_enabled: boolean;
  block_screenshot_android_value: string;
  block_screenshot_android_severity: string;
  max_offline_ios_enabled: boolean;
  max_offline_ios_value: string;
  max_offline_ios_severity: string;
  max_offline_android_enabled: boolean;
  max_offline_android_value: string;
  max_offline_android_severity: string;
}

export function sendUpdateMobileSecuritySettingsTelemetry(mobileSecuritySettings: IMobileSecuritySettings, location: MobileSecuritySettingsTelemetrySettingLocation) {
  Telemetry.sendEvent<UpdateMobileSecuritySettingsEvent>({
    type: MobileSecuritySettingsTelemetryEvents.mobile_security_settings,
    location: location,
    jailbroken_device_ios_enabled: mobileSecuritySettings.jailbroken_device?.iosConfig?.enabled,
    jailbroken_device_ios_value: mobileSecuritySettings.jailbroken_device?.iosConfig?.value,
    jailbroken_device_ios_severity: mobileSecuritySettings.jailbroken_device?.iosConfig?.severity.toString(),
    jailbroken_device_android_enabled: mobileSecuritySettings.jailbroken_device?.androidConfig?.enabled,
    jailbroken_device_android_value: mobileSecuritySettings.jailbroken_device?.androidConfig?.value,
    jailbroken_device_android_severity: mobileSecuritySettings.jailbroken_device?.androidConfig?.severity.toString(),
    block_screenshot_android_enabled: mobileSecuritySettings.screenshot?.androidConfig?.enabled,
    block_screenshot_android_value: mobileSecuritySettings.screenshot?.androidConfig?.value,
    block_screenshot_android_severity: mobileSecuritySettings.screenshot?.androidConfig?.severity?.toString(),
    max_offline_ios_enabled: mobileSecuritySettings.max_offline?.iosConfig?.enabled,
    max_offline_ios_value: mobileSecuritySettings.max_offline?.iosConfig?.value,
    max_offline_ios_severity: mobileSecuritySettings.max_offline?.iosConfig?.severity.toString(),
    max_offline_android_enabled: mobileSecuritySettings.max_offline?.androidConfig?.enabled,
    max_offline_android_value: mobileSecuritySettings.max_offline?.androidConfig?.value,
    max_offline_android_severity: mobileSecuritySettings.max_offline?.androidConfig?.severity.toString(),
  });
}
